/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface IUserGroup {
        id: number | string;
        name: string;
        description: string;
        enabled: boolean;
        organizationId: number;
        created: Date;
        isVnoDefault: boolean;
    }

    export class UserGroup implements IUserGroup {
        public id: number | string;
        public name: string;
        public description: string;
        public enabled: boolean;
        public organizationId: number;
        public created: Date;
        public isVnoDefault: boolean;

        public static createCopy(original: IUserGroup): UserGroup {
            return new UserGroup(original.id,
                                 original.name,
                                 original.description,
                                 original.enabled,
                                 original.organizationId,
                                 original.created,
                                 original.isVnoDefault);
        }

        public static createEmpty(): UserGroup {
            return new UserGroup();
        }

        constructor(id?: number | string,
                    name?: string,
                    description?: string,
                    enabled?: boolean,
                    organizationId?: number,
                    created?: Date,
                    isVnoDefault?: boolean) {
            this.id = id;
            this.name = name;
            this.description = description;
            this.enabled = enabled;
            this.organizationId = organizationId;
            this.created = created;
            this.isVnoDefault = isVnoDefault;
        }
    }
}